import React, {useState, useEffect} from "react";
import Modal from '@mui/joy/Modal';
import ModalClose from '@mui/joy/ModalClose';
import ModalDialog from '@mui/joy/ModalDialog';
import DialogTitle from '@mui/joy/DialogTitle';
import DialogContent from '@mui/joy/DialogContent';
import DialogActions from '@mui/joy/DialogActions';
import Divider from '@mui/joy/Divider';
import Grid from '@mui/joy/Grid';
import { toast } from 'react-toastify';
import Swal from "sweetalert2";
import axios from 'axios'
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import Select from '@mui/joy/Select';
import Option from '@mui/joy/Option';
import Input from '@mui/joy/Input';
import Checkbox from '@mui/joy/Checkbox';
import Typography from '@mui/joy/Typography';
// import { NumericFormat } from 'react-number-format';
import AccountService from "../../../services/accountService";
import ListService from "../../../services/listService";


function ModalNewAccount( {handleOpen, isOpen, listTerm}) {

    const [listPortfolioManagers, setListPortfolioManagers] = useState([])
    const [listPersonTypes, setListPersonTypes] = useState([])  

    useEffect(() => {
       loadList()
    }, []);

    const initModel = {
        account: '',
        name: '',
        portfolio_manager: '',
        portfolio_manager_id: '',
        emails: '',
        is_internal: false,
        account_manager: '',
        person_type_id: ''
    }
    const [sending, setSending] = useState(false)
    const [newModel, setNewModel] = useState(initModel)

    const doSave = async () => {
        if(validateNewForm()){
            try {  
                setSending(true)
                const response = await AccountService.setAccount(newModel)
                toast.success('Comitente creada!', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                handleOpen(false)
                setNewModel(initModel)
                setSending(false)
            } catch (e) {
                if (axios.isAxiosError(e)) {
                    const statusCode = e.response?.status
                    const error = e.response?.data.errors;
                    if(statusCode && statusCode !== 401){
                        Swal.fire({
                            title: 'ERROR',
                            text: error[0].detail,
                            icon: 'error',
                            confirmButtonText: 'OK',
                            confirmButtonColor: '#f13939'
                        })
                    }else{
                        sessionStorage.removeItem("userProfile");
                        window.location.reload();
                    }
                }
                setSending(false)
            }

        }else{
            toast.error('Cargue los datos correctamente!', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
    }

    const loadList = async () => {
        const response = await ListService.getPortfolioManagersList()
        setListPortfolioManagers(response.data)
        const responseTypes = await ListService.getPersonTypesList()
        setListPersonTypes(responseTypes.data)
    }

    const doChangePortfolioManager = (obj) => { 
        if(obj !== null){
            setNewModel({
                ...newModel, 
                portfolio_manager_id: obj.id,
                portfolio_manager: obj.name
            })
        }
    }
  
    const doChangePersonType = (obj) => { 
        if(obj !== null){
            setNewModel({
                ...newModel, 
                person_type_id: obj.id,
                person_type: obj.display_name
            })
        }
    }

    function validateNewForm (){
        let rta = true;
        if(newModel.account === '' || newModel.account === undefined  || newModel.account === null){ return false; } 
        if(newModel.name === '' || newModel.name === undefined  || newModel.name === null){ return false; } 
        if(newModel.account_manager === '' || newModel.account_manager === undefined  || newModel.account_manager === null){ return false; } 
        if(newModel.portfolio_manager_id === '' || newModel.portfolio_manager_id === undefined  || newModel.portfolio_manager_id === null){ return false; } 
        if(newModel.person_type_id === '' || newModel.person_type_id === undefined  || newModel.person_type_id === null){ return false; } 
        return rta;
    }

    return (
        <Modal
            aria-labelledby="close-modal-title"
            open={isOpen}
            onClose={() => handleOpen(false) }
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <ModalDialog>
                <ModalClose variant="outlined" />
                <DialogTitle>  Nuevo Comitente</DialogTitle>
                <Divider />
                <DialogContent>
                    <Grid container spacing={2} sx={{ flexGrow: 1 }}>
                        <Grid xs={6}>
                            <FormControl>
                                <FormLabel className="form-labels">Código <span style={{color:'red'}}>*</span></FormLabel>
                                <Input type="text" size="md" placeholder="Ingrese Abreviatura" value={newModel.account}  onChange={(e)=> setNewModel({...newModel, account: e.target.value}) }/>
                            </FormControl>
                        </Grid>
                        <Grid xs={6}>
                            <FormControl>
                                <FormLabel className="form-labels">Nombre <span style={{color:'red'}}>*</span></FormLabel>
                                <Input type="text" size="md" placeholder="Ingrese Nombre" value={newModel.name}  onChange={(e)=> setNewModel({...newModel, name: e.target.value}) }/>
                            </FormControl>
                        </Grid>                
                        <Grid xs={6}>
                            <FormControl>
                                <FormLabel className="form-labels">Tipo de Persona <span style={{color:'red'}}>*</span></FormLabel>
                                <Select 
                                    onChange={(event, newValue) => doChangePersonType( newValue) }
                                >
                                    {listPersonTypes.map( (ptype) => 
                                        <Option value={ptype} key={ptype.id} label={ptype.display_name}>{ptype.display_name}</Option>
                                    )}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid xs={6}>
                            <FormControl>
                                <FormLabel className="form-labels">Oficial de Cuenta <span style={{color:'red'}}>*</span></FormLabel>
                                <Select 
                                    onChange={(event, newValue) => doChangePortfolioManager( newValue) }
                                    // value={previewModel.contraparte}
                                >
                                    {listPortfolioManagers.map( (manager) => 
                                        <Option value={manager} key={manager.id} label={manager.name}>{manager.name}</Option>
                                    )}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid xs={6}>
                            <FormControl>
                                <FormLabel className="form-labels">Adm. de Cartera <span style={{color:'red'}}>*</span></FormLabel>
                                <Input type="text" size="md" placeholder="Ingrese Adm. de Cartera" value={newModel.account_manager}  onChange={(e)=> setNewModel({...newModel, account_manager: e.target.value}) }/>
                            </FormControl>
                        </Grid>
                        <Grid xs={6}>
                            <FormControl>
                                <FormLabel className="form-labels">Mail <span style={{color:'red'}}>*</span></FormLabel>
                                <Input type="text" size="md" placeholder="Ingrese Nombre" 
                                    value={newModel.emails}  onChange={(e)=> setNewModel({...newModel, emails: e.target.value}) }/>
                            </FormControl>
                        </Grid>
                        <Grid xs={6}>
                            <FormControl>
                                <Checkbox size="md" color="neutral" checked={newModel.is_internal} className="pt-4"
                                    onChange={(event) => { setNewModel({...newModel, is_internal: event.target.checked}) }}
                                    label={<Typography variant="label" className="MuiFormLabel-root form-labels css-1ckvkg0-JoyFormLabel-root">Uso interno</Typography>}
                                /> 
                            </FormControl>
                        </Grid>
                    </Grid>
                </DialogContent>
                <Divider />
                <DialogActions>
                    <button type="button" className="btn btn-info" onClick={() => doSave() } disabled={sending}> Guardar </button>
                    <button type="button" className="btn btn-outline-secondary"  onClick={() => handleOpen(false)}> Cerrar </button>                    
                </DialogActions>
            </ModalDialog>
        </Modal>

    );
}

export default ModalNewAccount;